import { FiX } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";


const RemoveModal = ({ item, onClose, onRemove }) => {
    // const navigate = useNavigate();
    const { toggleWishlist } = useWishlist();
const { removeFromCart } = useCart();
    return (
        // OVERLAY
        <div
            onClick={onClose}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4"
        >
            {/* MODAL BOX */}
            <div
                onClick={(e) => e.stopPropagation()}
                className="bg-white w-full max-w-md sm:max-w-lg rounded-2xl 
                   p-5 sm:p-8 relative shadow-xl"
            >
                {/* CLOSE ICON */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 sm:top-5 sm:right-5 
                     text-gray-600 hover:text-black"
                >
                    <FiX size={22} />
                </button>

                {/* ROW 1 */}
                <div className="flex gap-4 sm:gap-6 items-center">

                    {/* IMAGE */}
                    {/* <img
                        src={item.image}
                        alt={item.name}
                        className="w-full h-[300px] md:h-[500px] object-contain bg-black rounded-l-2xl"
                    /> */}

                    <div className="md:w-1/2 flex items-center justify-center bg-black">
  <img
    // src={review.images[current]}
    src={item.image}
                        alt={item.name}
    className="max-h-[500px] w-auto object-contain"
  />
</div>

                    {/* TEXT */}
                    <div>
                        <h3 className="text-lg sm:text-xl font-semibold">
                            Remove from bag
                        </h3>

                        <p className="text-sm sm:text-base 
                          text-gray-500 mt-1 sm:mt-2">
                            You can save it to your Wishlist
                            to buy it later
                        </p>
                    </div>
                </div>

                {/* BUTTON ROW */}
                <div className="flex gap-3 sm:gap-5 mt-6 sm:mt-8">

                    <button
                        onClick={onRemove}
                        className="flex-1 border py-2 sm:py-3 
                       text-xs sm:text-sm 
                       uppercase font-semibold 
                       hover:bg-gray-100 
                       rounded-lg transition"
                    >
                        REMOVE
                    </button>

                    <button onClick={() => {
                         toggleWishlist(item);             
    removeFromCart(item._id); 
                        onClose();
                        // navigate("/wishlist");
                    }}
                        className="flex-1 bg-black text-white 
                       py-2 sm:py-3 
                       text-xs sm:text-sm 
                       uppercase font-semibold 
                       hover:bg-gray-900 
                       rounded-lg transition"
                    >
                        MOVE TO WISHLIST
                    </button>

                </div>
            </div>
        </div>
    );
};

export default RemoveModal;